import unSubscribeByTokenSaga from './unSubscribeByTokenSaga'
import unSubscribeSaga from './unSubscribeSaga'
import unSubscribeInfoByTokenSaga from './unSubscribeInfoByTokenSaga'

const unsubscribeSaga = [unSubscribeByTokenSaga(), unSubscribeSaga(), unSubscribeInfoByTokenSaga()]

export default unsubscribeSaga
